import React, { useEffect } from "react";
//import s from "./style.module.css";
import Vizualisation from "../../../../components/Vizualisation";
import useVizualisation from "../../../../helpers/useVizualisation";
import tradeData from "../../data/trade.json";
import { chordDirected, ribbonArrow } from "d3-chord";
import { arc } from "d3-shape";
//import { ascending, descending } from "d3-array";

const margin = {
  top: 10,
  right: 10,
  bottom: 0,
  left: 10,
};

const innerRadius = 230 - margin.top - margin.bottom;
const outerRadius = innerRadius + 10;
const chord = chordDirected().padAngle(12 / innerRadius);
//.sortSubgroups(descending);

const chordArc = arc().innerRadius(innerRadius).outerRadius(outerRadius);

const ribbon = ribbonArrow()
  .radius(innerRadius - 0.5)
  .padAngle(1 / innerRadius)
  .headRadius(10);

const names = Array.from(
  new Set(tradeData.flatMap((d) => [d.source, d.target]))
);
const index = new Map(names.map((name, i) => [name, i]));
const matrix = Array.from(index, () => new Array(names.length).fill(0));
for (const { source, target, value } of tradeData)
  matrix[index.get(source)][index.get(target)] += value;

const ChordDiagram = ({ data, title, note, source, highlight }) => {
  const { ref, width, height, windowSize, inView } = useVizualisation();
  const chartWidth = width - margin.left - margin.right;
  const chartHeight = 500 - margin.top - margin.bottom;

  const chords = chord(matrix);
  const colorScale = {
    "Open transfers": "#481F7C",
    "Conditional transfers": "#F2C118",
    "Controlled transfers": "#31989E",
  };

  const chordsHighlighted = chords.filter((d) => {
    if (highlight == "controlled") {
      return d.target.index == 1 && d.source.index == 1;
    }
    if (highlight == "openconditional") {
      return (
        (d.target.index == 1 && d.source.index == 1) ||
        (d.target.index == 0 && d.source.index == 0) ||
        (d.target.index == 2 && d.source.index == 2)
      );
    }
    if (highlight == "all") {
      return true;
    }
  });

  return (
    <Vizualisation
      title={title}
      note={note}
      source={source}
      ref={ref}
      size="large"
    >
      <svg
        width={width}
        height={500}
        viewBox={[-width / 2, -500 / 2, width, 500]}
      >
        <g
          className="chart"
          transform={`translate(${margin.left}, ${margin.top})`}
        >
          <path
            id={"textpath"}
            d={arc()({ outerRadius, startAngle: 0, endAngle: 2 * Math.PI })}
            fill="none"
          ></path>
          {chordsHighlighted.map((d) => {
            return (
              <path
                d={ribbon(d)}
                fill={
                  d.target.index == d.source.index
                    ? colorScale[names[d.target.index]]
                    : "#cccccc"
                }
                opacity={d.target.index == d.source.index ? 1 : 0.7}
              ></path>
            );
          })}
          {chords.groups.map((d) => {
            return (
              <>
                <path d={chordArc(d)} fill={colorScale[names[d.index]]}></path>
                <text
                  dy="-3px"
                  fontSize="12px"
                  fill={colorScale[names[d.index]]}
                >
                  <textPath
                    href="#textpath"
                    startOffset={d.startAngle * outerRadius}
                  >
                    {names[d.index]}
                  </textPath>
                </text>
              </>
            );
          })}
        </g>
      </svg>
    </Vizualisation>
  );
};

export default ChordDiagram;
